import Button from '@mui/material/Button';

import { ModalType, useModal } from 'reservations/base/providers/ModalProvider';
import {
  useIsLead,
  useNumberOfGuests
} from 'reservations/booking/providers/BookingProvider';

interface Props {
  buttonText: string;
}

export const ChecklessEnrollmentButtonsContainer = ({ buttonText }: Props) => {
  const { open } = useModal();
  const isLead = useIsLead();
  const hasInvitedGuests = useNumberOfGuests() > 1;

  return isLead ? (
    <>
      <Button onClick={() => open(ModalType.AddCardToEnroll)}>
        {buttonText}
      </Button>
      {hasInvitedGuests && (
        <Button
          onClick={() => open(ModalType.AddCardToSplitLead)}
          color="secondary"
        >
          Split the Bill
        </Button>
      )}
    </>
  ) : (
    <Button onClick={() => open(ModalType.AddCardToSplitGuest)}>
      Split the Bill
    </Button>
  );
};
